
import gql from 'graphql-tag';
import QuickGuideWrapper from '../../../components/quick-guide/QuickGuideWrapper.vue';
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
import shortTermSavPlanScenariosQuery from '~/apollo/queries/product/shortTermSavPlanScenarios';
import insuranceCompaniesQuery from '~/apollo/queries/product/insuranceCompanies';
import shortTermsSavTooltips from '~/apollo/queries/product/tooltips/shortTermsSavTooltips';
import commonProductMixins from '~/mixins/commonProductMixins.js';
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import insuranceGuideQuery from '@/apollo/queries/home/insuranceguide'
import productShortcutMixins from "~/mixins/productShortcutMixins.js";
import apolloQuickGuideMixins from '~/mixins/apolloQuickGuideMixins';
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  name: 'ProductsShortTermSavingsListingPage',
  mixins: [commonProductMixins, productPromotionMixins, productShortcutMixins, apolloQuickGuideMixins, productInsuranceNameMixins],

  apollo: {
    $loadingKey: 'loading',
    shortTermSavPlanScenarios: {
      query: gql`
        ${shortTermSavPlanScenariosQuery}
        ${productPromotionFragment}
      `,
      prefetch: false,
      variables() {
        let tmpComp;
        tmpComp = undefined;
        let tmpPremiumTerm;
        tmpPremiumTerm = undefined;
        let tmpYear;
        tmpYear = undefined;
        let tmpBrokerInd;
        tmpBrokerInd = undefined;

        if (this.filter.insCompValue?.length) {
          tmpComp = this.filter.insCompValue.map((x) => x.value);
        }

        if (this.filter.paymentTermValue?.value !== '-1') {
          tmpPremiumTerm = parseInt(this.filter.paymentTermValue?.value);
        }

        if (this.filter.maturityValue?.value !== '-1') {
          tmpYear = parseInt(this.filter.maturityValue?.value);
        }

        if (this.filter.advisorAssistanceValue) {
          tmpBrokerInd = this.filter.advisorAssistanceValue;
        }

        return {
          insCompCode: tmpComp,
          currency: parseInt(this.filter.currencyValue?.value),
          premium_term: tmpPremiumTerm,
          year: tmpYear,
          broker_ind: tmpBrokerInd,
          locale: this.currentLocale,
        };
      },
    },
    insuranceCompanies: {
      query: insuranceCompaniesQuery,
      prefetch: true,
      variables() {
        return {
          show_shortsavings: true,
        };
      },
      update(data) {
        return data.insuranceCompanies.data.map((item) => {
          const translations = item.attributes.insurance_company_translations.data;
          // console.debug(translations);
          const filteredTranslations = this.getFilteredTranslations(translations);
          return {
            value: item.attributes.code,
            text:
              filteredTranslations[0].attributes.name +
              ' | ' +
              filteredTranslations[1].attributes.name,
          };
        });
      },
    },
    shortTermsSavTooltips: {
      query: shortTermsSavTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data);
      },
    },
  },
  data() {
    return {
      loading: 0,
      currentLocale: this.$normalizeLocale(this.$i18n.locale),
      filter: {
        insCompValue: [],

        currencyValue: { value: this.$route.query.currency ? this.$route.query.currency : '1', text: '' },
        currencyOptions: [
          { value: '1', text: 'USD' },
          { value: '2', text: 'HKD' },
          { value: '3', text: 'RMB' },
        ],

        paymentTermValue: {
          value: this.$route.query.payment_term ? this.$route.query.payment_term : '-1',
          text: this.$t('products.any'),
        },
        paymentTermOptions: [
          { value: '-1', text: this.$t('products.any') },
          { value: '1', text: this.$t('products.prepaid') },
          { value: '2', text: '2 ' + this.$t('products.yearsUnit') },
          { value: '3', text: '3 ' + this.$t('products.yearsUnit') },
        ],

        maturityValue: { value: this.$route.query.target_period ? this.$route.query.target_period : '5', text: '' },
        maturityOptions: [
          { value: '1', text: '1 ' + this.$t('products.yearUnit') },
          { value: '2', text: '2 ' + this.$t('products.yearsUnit') },
          { value: '3', text: '3 ' + this.$t('products.yearsUnit') },
          { value: '4', text: '4 ' + this.$t('products.yearsUnit') },
          { value: '5', text: '5 ' + this.$t('products.yearsUnit') },
          { value: '6', text: '6 ' + this.$t('products.yearsUnit') },
          { value: '7', text: '7 ' + this.$t('products.yearsUnit') },
          { value: '8', text: '8 ' + this.$t('products.yearsUnit') },
        ],

        advisorAssistanceValue: this.$route.query.advisorAssistance === 'true',
      },
      perPage: 15,
      currentPage: 1,
      shortTermSavPlanScenarios: null,
      insuranceCompanies: null,

      sortingData: {
        title: this.$t('products.sort'),
        sortValue: { value: this.$route.query.sort ? this.$route.query.sort : 'score', text: '' },
        // sortingOptions: this.sortingOptions(),
      },
    };
  },
  computed: {
    modalOpen() {
        return this.$store.getters['modal/showDisplayMobileFilter'].isOpen
    },
    mainQueryLoading() {
      return this.$apollo.queries.shortTermSavPlanScenarios.loading;
    },

    sortingOptions() {
      return [
        { value: 'score', text: this.$t('products.shortSavings.st_shortTermSavingsScore') },
        {
          value: 'g_return_ratio',
          text: this.getReturnRatioLabel(
            this.filter.maturityValue?.value,
            this.$t('products.shortSavings.st_guaranteedReturnRatioHightoLow')
          ),
        },
        {
          value: 'g_irr',
          text: this.getReturnRatioLabel(
            this.filter.maturityValue?.value,
            this.$t('products.shortSavings.st_guaranteedIRRHightoLow')
          ),
        },
        { value: 'min_total_premium', text: this.$t('products.shortSavings.st_minimumTotalPremium') },
      ];
    },

    resultMessage() {
      if (this.mainQueryLoading) {
        return this.$t('products.shortSavings.st_result').replace('$num', '{ }');
      } else {
        return this.$t('products.shortSavings.st_result').replace('$num', this.rows);
      }
    },

    displayProducts() {
      return this.sortedItem?.map((item) => ({
        id: item.scenario_code,
        category: this.category,
        scenarioId: item.scenarioID,
        showFiveStarBadge: this.$formatShowFiveStarBadge(item.overall_star),
        showTrending: false,

        productLink: this.$extendPath(
          this.$route.path,
          '/' + item.scenario_code + '?year=' + this.filter.maturityValue?.value
        ),
        productName: item.plan_name,
        insuranceCompany: {
          name: item.insurer_name_first + ' | ' + item.insurer_name_second,
          code: item.insurer_code,
          logoSrc: item.insurer_logo?.data?.attributes.url,
          logoAlt: item.insurer_name_first,
        },
        userRating: {
          score: item.overall_star,
          numberOfRatedUser: '0',
        },
        tenlifeScore: {
          score: parseFloat(this.getScore(item)),
          description: this.$t('products.shortSavings.st_shortTermSavingsScore'),
          toolTipHtml: this.getTooltipContentByKey('st_shortTermSavingsScore'),
        },
        features: [
          {
            text: this.getCurrency(item.currency),
            type: 'currency',
          },
          {
            text:
              parseInt(item.payment_term) === 1
                ? this.$t('products.prepaid')
                : item.payment_term + this.$t('products.shortSavings.st_yearpayment'),
            type: 'payment_term',
          },
          {
            text: item.maturity + this.$t('products.shortSavings.st_yearmaturity'),
            type: 'target_period',
          },
        ],
        keyItems: [
          {
            value: this.$formatPercentageDP(item.financial_result[0].attributes.guarantee_irr_surrender, 2),
            key: this.getReturnRatioLabel(
              this.filter.maturityValue?.value,
              this.$t('products.shortSavings.st_targetPeriodGuaranteedIRR')
            ),
            topSubText: '',
            toolTipHtml: this.getTargetPeriodGuaranteedIRRTooltip(),
            symbolValue: '',
            originalValue: '',
            negative: item.financial_result[0].attributes.guarantee_irr_surrender < 0,
            isTextBlack: true,
          },
          {
            // value: (item.gbey > 1)? item.gbey + " " + this.$t('products.yearsUnit') : item.gbey + " " + this.$t('products.yearUnit'),
            value:
              item.gbey > 0
                ? item.gbey
                : '<span style="white-space: nowrap;">' +
                  this.$t('products.shortSavings.st_gbey_immediate') +
                  '</span>',
            key: this.$t('products.shortSavings.st_guaranteedBreakeven'),
            topSubText: '',
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
            isTextBlack: false,
          },
          {
            value: this.$formatPrice(item.min_total_premium),
            key: this.$t('products.shortSavings.st_minimumTotalPremium'),
            topSubText: item.currency_code,
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
            isTextBlack: false,
          },
        ],
        mobileKeyItems: [
          {
            value: this.$formatPercentageDP(item.financial_result[0].attributes.guarantee_irr_surrender, 2),
            key: this.getReturnRatioLabel(
              this.filter.maturityValue?.value,
              this.$t('products.shortSavings.st_targetPeriodGuaranteedIRR')
            ),
            topSubText: '',
            toolTipHtml: this.getTargetPeriodGuaranteedIRRTooltip(),
            symbolValue: '',
            originalValue: '',
            negative: item.financial_result[0].attributes.guarantee_irr_surrender < 0,
            isTextBlack: item.financial_result[0].attributes.guarantee_irr_surrender < 0 ? false:true,
          },
          {
            // value: (item.gbey > 1)? item.gbey + " " + this.$t('products.yearsUnit') : item.gbey + " " + this.$t('products.yearUnit'),
            value:
              item.gbey > 0
                ? item.gbey
                : '<span style="white-space: nowrap;">' +
                  this.$t('products.shortSavings.st_gbey_immediate') +
                  '</span>',
            key: this.$t('products.shortSavings.st_guaranteedBreakeven'),
            topSubText: '',
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
            isTextBlack: true,
          },
          {
            value: this.$formatPrice(item.min_total_premium),
            key: this.$t('products.shortSavings.st_minimumTotalPremium'),
            topSubText: item.currency_code,
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
            isTextBlack: false,
            isTextBold: true
          },
        ],
        compactKeyItems: [
          {
            value: this.$formatPrice(item.min_total_premium),
            key: this.$t('products.shortSavings.st_minimumTotalPremium'),
            topSubText: item.currency_code,
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
            isTextBlack: false,
            isTextBold: true,
          },
          // {
          //   value: this.$formatPercentageDP(item.financial_result[0].attributes.guarantee_return_ratio, 1),
          //   key: this.getReturnRatioLabel(
          //     this.filter.maturityValue?.value,
          //     this.$t('products.shortSavings.st_guaranteedReturnRatio')
          //   ),
          //   topSubText: '',
          //   toolTipHtml: this.getTooltipContentByKey(
          //     'st_' + this.filter.maturityValue?.value + 'thyearGuaranteedReturnRatio'
          //   ),
          //   symbolValue: '',
          //   originalValue: '',
          //   negative: item.financial_result[0].attributes.guarantee_return_ratio < 1,
          //   isTextBlack: item.financial_result[0].attributes.guarantee_return_ratio < 1? false:true,
          // },
        ],
        promotion: {
          category:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
          title:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
          ctaButtonLink:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
          ctaButtonText:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
          promotionId: item.product_promotion?.id,
          scenarioId: item.scenarioID,
          hide: item.hide,
          lastCall: item.promotion_last_call

        },
        mainButtonCTA: {
          text: item.decoder_cta_text,
          link: item.decoder_cta_link,
        },
        showShortcut: item.shortcut,
        price: {
          originalPrice: '',
          discountPrice: this.$formatPercentageDP(item.financial_result[0].attributes.guarantee_return_ratio, 1),
          prefix: '',
          postfix: '',
          subText: this.getReturnRatioLabel(this.filter.maturityValue.value, this.$t('products.shortSavings.st_guaranteedReturnRatio')),
          toolTipHtml: this.getTooltipContentByKey(
            'st_' + this.filter.maturityValue?.value + 'thyearGuaranteedReturnRatio'
          ),
          negative: (item.financial_result[0].attributes.guarantee_return_ratio < 1),
          isTextBlack: true
        },
      }));
    },

    rows() {
      if (this.simpleItems) {
        return this.simpleItems.length;
      }
      return null;
    },

    sortedItem() {
      if (this.sortingData.sortValue.value === 'score') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort(
              (a, b) =>
                b.rating - a.rating ||
                b.financial_result[0].attributes.guarantee_return_ratio -
                  a.financial_result[0].attributes.guarantee_return_ratio ||
                b.financial_result[0].attributes.guarantee_irr_surrender -
                  a.financial_result[0].attributes.guarantee_irr_surrender || a.min_total_premium - b.min_total_premium
            );
        }
      } else if (this.sortingData.sortValue.value === 'g_return_ratio') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort(
              (a, b) =>
                b.financial_result[0].attributes.guarantee_return_ratio -
                  a.financial_result[0].attributes.guarantee_return_ratio ||
                b.financial_result[0].attributes.guarantee_irr_surrender -
                  a.financial_result[0].attributes.guarantee_irr_surrender ||
                b.rating - a.rating ||
                a.min_total_premium - b.min_total_premium
            );
        }
      } else if (this.sortingData.sortValue.value === 'g_irr') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort(
              (a, b) =>
                b.financial_result[0].attributes.guarantee_irr_surrender -
                  a.financial_result[0].attributes.guarantee_irr_surrender ||
                b.financial_result[0].attributes.guarantee_return_ratio -
                  a.financial_result[0].attributes.guarantee_return_ratio ||
                b.rating - a.rating ||
                a.min_total_premium - b.min_total_premium
            );
        }
      } else if (this.sortingData.sortValue.value === 'min_total_premium') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort(
              (a, b) =>
                a.min_total_premium - b.min_total_premium ||
                b.rating - a.rating ||
                b.financial_result[0].attributes.guarantee_return_ratio -
                  a.financial_result[0].attributes.guarantee_return_ratio ||
                b.financial_result[0].attributes.guarantee_irr_surrender -
                  a.financial_result[0].attributes.guarantee_irr_surrender
            );
        }
      }
      return null;
    },

    simpleItems() {
      if (this.shortTermSavPlanScenarios && !this.$apollo.queries.shortTermSavPlanScenarios.loading) {
        // preprocess the scenarios first
        const targetYear = this.filter.maturityValue.value;
        const scenarios = this.shortTermSavPlanScenarios.data.filter(
          (item) => item.attributes.maturity >= targetYear
        );


        return scenarios.map((item) => {
          let promotions = null;
          let promotion = null;
          let promotion_last_call = null;

          const planName = item.attributes.short_term_sav_plan.data.attributes.short_term_sav_plan_translations.data[0].attributes.name;
          const insurer = item.attributes.short_term_sav_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
          let decoderCTALink = this.$generateWhatsappCTALink(this.$t('products.shortSavings.st_categoryName'), insurer, planName);
          let decoderCTAText = '';
          let hide = Boolean;
          hide = false;

          // check scenario level promo first , then plan level promotion
          if (item.attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.product_promotions.data;
          }
          if (item.attributes.short_term_sav_plan.data.attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.short_term_sav_plan.data.attributes.product_promotions.data;
          }

          if(promotions != null) {
            promotion = this.checkPromotionValid(promotions);
            promotion_last_call = this.checkPromotionLastCall(promotion);

            if (!promotion) {
              promotion = null;
            } else if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
              decoderCTALink =
                promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
              decoderCTAText = this.$t('products.product_website');
              const translation = promotion.attributes.product_promotion_translations?.data[0];
              hide = translation.attributes?.HideBanner;
            }
          }

          const financialResult = item.attributes.short_term_sav_fins.data.filter(
            (item) => item.attributes.year === parseInt(this.filter.maturityValue.value)
          );

          const shortcut = this.getProductShortcut(item.attributes);

          // console.log(item.attributes.scenario_code)
          // console.log("target:"+parseInt(this.filter.maturityValue.value))
          // console.log(item.attributes.short_term_sav_fins.data);
          // console.log(item.attributes.short_term_sav_fins.data.filter(
          //   (item) => item.attributes.year === parseInt(this.filter.maturityValue.value)
          // ));

          const filteredTranslations = this.getFilteredTranslations(item.attributes.short_term_sav_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
          .insurance_company_translations.data[0].attributes.localizations.data);

          return {
            scenario_code: item.attributes.scenario_code,
            payment_term: item.attributes.premium_term,
            // rating: item.attributes.rating, OLD rating
            rating: financialResult[0]?.attributes.rating.toFixed(1),
            gbey: parseInt(item.attributes.gbey),
            currency_code: item.attributes.currency.data.attributes.code,
            currency: item.attributes.currency.data.attributes.currency_translations.data[0].attributes,
            min_total_premium: item.attributes.min_total_premium,
            maturity: item.attributes.maturity,

            // // plan
            plan_name: planName,
            online_purchase: item.attributes.short_term_sav_plan.data.attributes.online_purchase,

            // // insurer
            insurer_name_first:
              item.attributes.short_term_sav_plan.data.attributes.product.data.attributes.insurance_company.data
                .attributes.insurance_company_translations.data[0].attributes.name,
            insurer_name_second:
              filteredTranslations[0].attributes.name,
            insurer_logo:
              item.attributes.short_term_sav_plan.data.attributes.product.data.attributes.insurance_company.data
                .attributes.logo,
            insurer_code:
              item.attributes.short_term_sav_plan.data.attributes.product.data.attributes.insurance_company.data
                .attributes.code,

            // // financial details
            financial_result_year1: item.attributes.short_term_sav_fins.data.filter(
              (item) => item.attributes.year === 1
            ),
            financial_result: financialResult,
            product_promotion: promotion,
            decoder_cta_link: decoderCTALink,
            decoder_cta_text: decoderCTAText,

            scenarioID: item.id,
            hide,
            promotion_last_call: promotion_last_call,
            shortcut: shortcut,
          };
        });
      }
      return null;
    },
    slug() {
      return 'st-savings'
    },
    selectedSortingLogic() {
      return this.sortingData.sortValue.value
    },
  },

  watch: {
    'filter.maturityValue': {
      handler(newValue, oldValue){
        // console.log("filter value changed");
        if (newValue !== oldValue) {
          const filterValueToFix = {
            filterValuePath: 'sortingData.sortValue',
            filterOptionsPath: 'sortingOptions',
            queryKey: 'sort',
            defaultValue: 'score',
          };
          this.fixFilterValue(filterValueToFix);
        }
      },
      deep: true,
    }
  },

  created() {
    const filterValuesToWatch = [
      {
        filterValuePath: 'filter.paymentTermValue',
        filterOptionsPath: 'filter.paymentTermOptions',
        queryKey: 'payment_term',
        defaultValue: '-1',
      },
      {
        filterValuePath: 'filter.maturityValue',
        filterOptionsPath: 'filter.maturityOptions',
        queryKey: 'target_period',
        defaultValue: '5',
      },
      {
        filterValuePath: 'filter.currencyValue',
        filterOptionsPath: 'filter.currencyOptions',
        queryKey: 'currency',
        defaultValue: '1',
      },
      {
        filterValuePath: 'sortingData.sortValue',
        filterOptionsPath: 'sortingOptions',
        queryKey: 'sort',
        defaultValue: 'score',
        ignoreFix: true,
      },
      {
        filterValuePath: 'filter.insCompValue',
        filterOptionsPath: 'insuranceCompanies',
        queryKey: 'ins_comp[]',
        defaultValue: [],
        ignoreFix: true,
        type: 'array',
      },
      {
        filterValuePath: 'filter.advisorAssistanceValue',
        queryKey: 'advisorAssistance',
        defaultValue: false,
        ignoreFix: true,
        type: 'checkbox',
      },
    ];

    this.createFilterWatchers(filterValuesToWatch);
    this.fixFilterValues(filterValuesToWatch);
  },

  mounted() {
    const filterValueToFix = {
      filterValuePath: 'sortingData.sortValue',
      filterOptionsPath: 'sortingOptions',
      queryKey: 'sort',
      defaultValue: 'score',
    };
    this.fixFilterValue(filterValueToFix);

    const filterArrayValueToFix = {
      filterValuePath: 'filter.insCompValue',
      filterOptionsPath: 'insuranceCompanies',
      queryKey: 'ins_comp[]',
    };
    this.fixFilterArrayValueDueToQueryString(filterArrayValueToFix);
  },

  methods: {
    getCurrency(curr) {
      if (this.currentLocale === 'zh-Hant-HK') {
        return curr.text;
      } else {
        return curr.localizations.data[0].attributes.text;
      }
    },

    getScore(product) {
      return this.$formatScore(
        product.financial_result[0].attributes.rating ? product.financial_result[0].attributes.rating : 0
      );
    },

    getReturnRatioLabel(index, label) {
      if (this.currentLocale === 'en') {
        return label.replace('$num', this.$ordinalSuffix(index));
      } else if (this.currentLocale === 'zh-Hant-HK') {
        return label.replace('$num', index);
      }
    },

    getTooltipContentByKey(mKey) {
      return this.shortTermsSavTooltips?.ShortTermSav?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },

    getTargetPeriodGuaranteedIRRTooltip() {
      const tooltip = this.getTooltipContentByKey('st_targetPeriodGuaranteedIRR');
      const maturityValue = this.filter.maturityValue?.value.toString();
      const processedMaturityYearValue =
        this.currentLocale === 'zh-Hant-HK' ? maturityValue : this.$ordinalSuffix(parseInt(maturityValue));
      return tooltip?.replace('{replace_year}', processedMaturityYearValue);
    },
  },
  components: {
    QuickGuideWrapper
  }
};
